import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Result
      status="404"
      title="404"
      subTitle={t('not_found.error_message')}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('not_found.back_home_button_text')}
        </Button>
      }
    />
  )
}

export default NotFoundPage
